import { Component, Inject, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer} from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  cctvCreds: any;
  cctvFrameURL:any
  cctvURL:any;
  

  constructor(public campuscctvserviceservice: CampuscctvserviceService, @Inject(MAT_DIALOG_DATA) public data: any,private spinner: NgxSpinnerService, private domSanitizer: DomSanitizer) { }
  ngOnInit(): void {
    console.log(this.data);
    // this.getCCTVFrameURL
    this.spinner.show();
    this.campuscctvserviceservice.getChannel(this.data.cctvDetId, this.data.channelsNo).subscribe(
      {
        next: (httpResponse: any) => {
          this.cctvCreds = httpResponse;
          console.log('cctvdetails', this.cctvCreds);
         const URL = environment.devStreamURL +`/buildingCctvFrame?buildingId=${this.cctvCreds[0].buildingId}&dvrIPAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&portNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}`
         this.cctvURL = this.domSanitizer.bypassSecurityTrustResourceUrl(URL);
         this.spinner.hide();
        },
        error: (err) => {
          console.log('error', err);
          this.spinner.hide();
        },
        complete: () => {
          console.log('completed!');

        }
      }
    )
  }
  



  // CctvDetails() {
  //   let payload = {
  //     "cctvDetails": this.cctvCreds[0]
  //   }
  //   this.campuscctvserviceservice.postCctvDetails(payload).subscribe(
  //     {
  //       next: (HttpResponse: any) => {
  //         this.cctvCreds = HttpResponse
  //         console.log('data', this.cctvCreds);
  //       },
  //       error: (err) => {
  //         console.log('Error', err);
  //       },
  //       complete: () => {
  //         console.log('completed!');
  //       }
  //     }
  //   )
  // }
}
